// Data
import textTags from '../data/translations/textTags.json';
import uiTags from '../data/translations/uiTags.json';

const tags = { ...textTags, ...uiTags };
const DEFAULT_LANGUAGE = 'en';

const translateToLanguage = (tag, language) => {
  // Tag doesn't exist -> return empty string
  // No language is provided -> use default language
  // No translation for desired language -> use default language
  // No translation for default language -> return empty string
  if (!tags[tag]) return '';
  if (!language || !tags[tag][language]) return tags[tag][DEFAULT_LANGUAGE] || '';
  return tags[tag][language];
};

export { translateToLanguage };
